import List from "../list/List";

export default class Queue {
    constructor(list) {
        if (list) {
            this._list = list;
        } else {
            this._list = new List();
        }
    };

    peek() {
        return this._list.first();
    };

    enqueue(data) {
        this._list.push(data);
    };

    dequeue() {
        return this._list.shift();
    };

    clear() {
        this._list = new List();
    };

    getIterator() {
        return this._list.getIterator();
    };

    contains(data) {
        return this._list.contains(data);
    };

    size() {
        return this._list.size();
    };

    isEmpty() {
        return this._list.isEmpty();
    };

    toArray() {
        return this._list.toArray();
    };
}